import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HomePageComponent } from './home-page/home-page.component';
import { ChartModule } from 'angular-highcharts';
import { SharedModule } from '../shared/shared.module';
import { DashboardModule } from '../dashboards/dashboard.module';
import { I18NextModule } from 'angular-i18next';

@NgModule({
  declarations: [
    HomePageComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ChartModule,
    SharedModule,
    DashboardModule,
    I18NextModule.forRoot(),
  ],
  exports: [
    HomePageComponent
  ],
})
export class HomeModule { }